document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ja-birthstone-card').forEach((card) => {
    const productLink = card.querySelector('.ja-card-link');
    const price = card.querySelector('.ja-card-price');
    if (!productLink || !price) return;

    const footer = document.createElement('div');
    footer.className = 'ja-card-footer';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ja-card-add';
    button.setAttribute('aria-label', 'Add to cart');
    button.innerHTML = `
      <svg aria-hidden="true" focusable="false" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"/>
        <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 1 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
      </svg>
      <span>Add to cart</span>
    `;

    price.remove();
    footer.append(button, price);
    card.append(footer);

    button.addEventListener('click', async () => {
      if (button.disabled) return;

      button.disabled = true;
      button.classList.add('loading');

      try {
        const productResponse = await fetch(`${productLink.pathname}.js`);
        if (!productResponse.ok) throw new Error('Unable to load product');
        const product = await productResponse.json();
        const variant = product.variants.find((item) => item.available);
        if (!variant) throw new Error('Product is sold out');

        const cartNotification = document.querySelector('cart-notification');
        const formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', '1');
        if (cartNotification) {
          formData.append('sections', cartNotification.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        const cartResponse = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const result = await cartResponse.json();
        if (!cartResponse.ok || result.status) throw new Error(result.description || 'Unable to add item');

        if (cartNotification) {
          cartNotification.setActiveElement?.(button);
          cartNotification.renderContents(result, 'drawer');
        }

        button.classList.add('success');
        button.querySelector('span').textContent = 'Added';
      } catch (error) {
        button.classList.add('error');
        button.querySelector('span').textContent = error.message || 'Try again';
      } finally {
        button.classList.remove('loading');
        button.disabled = false;
      }
    });
  });
});
